module.exports = __webpack_public_path__ + "static/img/bg-tr.48c4f897.png";